import { render } from "./CreationTaskTools.vue?vue&type=template&id=345ceeda&scoped=true"
import script from "./CreationTaskTools.vue?vue&type=script&lang=js"
export * from "./CreationTaskTools.vue?vue&type=script&lang=js"

import "./CreationTaskTools.vue?vue&type=style&index=0&id=345ceeda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345ceeda"]])

export default __exports__